import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { interval, from, Observable, of, timer, throwError } from 'rxjs';
import { debounceTime, delay, flatMap, withLatestFrom, map, switchMap, takeWhile, catchError, mergeMap, filter } from 'rxjs/operators';

// import {
//   ApplicationActionType, DelayedAction, GetProblems, SetProblems
// } from './application.action';

// import { ApplicationService } from '../../services/application.service';

// import {
//   ApplicationState, AppState
// } from './application.state';

@Injectable()
export class AuthEffects {

//   @Effect()
//   delayedAction$ = this.actions$.pipe(
//     ofType(ApplicationActionType.DelayedAction),
//     delay(0),
//     flatMap((action: DelayedAction) => {
//       return action.payload;
//     })
//   );

//   @Effect()
//   getProblems$ = this.actions$.pipe(
//     ofType(ApplicationActionType.GetProblems),
//     switchMap((action: GetProblems) =>
//       this.applicationService.getProblems()
//     ),
//     flatMap((data) => [
//       new SetProblems(data)
//     ])
//   );

  constructor(
    private actions$: Actions,
    // private store$: Store<AppState>,
    // private applicationService: ApplicationService
  ) { }

}
